// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AG_t2","left":"styles_left__3yaOJ"};